<script>
  import { slide, fade } from "svelte/transition";
  import { circIn } from "svelte/easing";
  import { theme, currentQuote, isShareOpen } from "../../stores/store";

  let clipboardAvailable: boolean = true;
  let copied: boolean = false;
  let themeValue: Number;
  let shareURL: string;
  let urlHostName: string = window.location.origin;

  $: themeValue = $theme === "dark" ? 0 : 1;
  $: shareURL = urlHostName + "/?q=" + $currentQuote["_id"] + themeValue;

  if (!navigator.clipboard) {
    clipboardAvailable = true;
  }

  async function copyToClipboard() {
    let inputValue = document.getElementById("url") as HTMLInputElement;
    try {
      await navigator.clipboard.writeText(inputValue.value);
      copied = true;
      setTimeout(() => {
        copied = false;
      }, 1500);
    } catch (err) {
      console.log("Can't copy to clipboard");
    }
  }

  function close() {
    let currentStatus = $isShareOpen ? false : true;
    isShareOpen.set(currentStatus);
  }
</script>

{#if $isShareOpen}
  <div
    class="share-wrapper"
    in:slide={{ duration: 250, easing: circIn }}
    out:slide={{ delay: 150 }}
  >
    {#if copied}
      <div class="copied-notification is-flex is-justify-content-center">
        Copied to Clipboard!
      </div>
    {/if}
    <div
      class="input-wrapper"
      in:fade={{ duration: 250, delay: 250 }}
      out:fade={{ duration: 150 }}
    >
      <input id="url" type="text" value={shareURL} readonly />
      <div class="is-flex is-align-items-center">
        {#if clipboardAvailable}
          <button on:click={copyToClipboard}>
            <i class="far fa-copy fa-2x" />
          </button>
        {/if}
      </div>
    </div>
    <div
      class="is-flex is-justify-content-center"
      in:fade={{ duration: 250, delay: 250 }}
      out:fade={{ duration: 150 }}
    >
      <button class="close" on:click={close}
        ><i class="far fa-times fa-2x" /></button
      >
    </div>
  </div>
{/if}

<style lang="scss">
  button {
    border: 0;
    background: none;
    padding: 20px;
    margin-top: 5px;
  }
  .copied-notification {
    margin: 0 0 25px 0;
    font-size: $fontSize-small;
  }
  .input-wrapper {
    display: flex;
    align-items: center;
    width: 50vw;
    background: #ffffff;
    border: 1px solid transparent;
    border-radius: 30px;
    padding: 0 15px;
    input {
      border: none;
      border-radius: 30px;
      margin: 0 15px;
      box-sizing: border-box;
      padding: 15px 10px;
      font-size: $fontSize-medium;
      margin: 0;
      outline: none;
      flex-grow: 1;
    }
    button {
      color: grey;
      background: none;
      border: none;
      padding: 0;
      &:hover {
        color: $dark;
      }
    }
  }
</style>
